export const failureImageContainerStyle = {
  paddingLeft: "8px",
  marginTop: "60px"
};